import { BoxLeadDraftEntity } from "@modules/boxLead/entities/boxLeadInput"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useBoxLeadCreate = () => {
  const { boxLeadApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: createBoxLead, isPending } = useMutation({
    mutationFn: async (leadDraft: BoxLeadDraftEntity) => {
      await boxLeadApi.createBoxLead(BoxLeadDraftEntity.toDto(leadDraft))
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["boxLeads"],
      })
    },
  })

  return {
    createBoxLead,
    isPending,
  }
}

export const useBoxLeadUpdate = () => {
  const { boxLeadApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: updateBoxLead, isPending } = useMutation({
    mutationFn: async ({ leadId, leadDraft }: { leadId: string; leadDraft: BoxLeadDraftEntity }) => {
      await boxLeadApi.updateBoxLead(leadId, BoxLeadDraftEntity.toDto(leadDraft))
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["boxLeads"],
      }),
        queryClient.invalidateQueries({
          queryKey: ["boxLead", variables.leadId],
        })
    },
  })

  return {
    updateBoxLead,
    isPending,
  }
}

export const useBoxLeadDelete = () => {
  const { boxLeadApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteBoxLead, isPending } = useMutation({
    mutationFn: async (leadId: string) => {
      await boxLeadApi.deleteBoxLead(leadId)
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["boxLeads"],
      })
      queryClient.invalidateQueries({
        queryKey: ["boxLead", variables],
      })
    },
  })

  return {
    deleteBoxLead,
    isPending,
  }
}
